import { defineFcm } from '../shared/factory';

export const FCM_PSF_CONTEXTUAL_BANDITS_ENABLED = defineFcm('psf_contextual_bandits_enabled')
	.asBoolean()
	.withDefault(false)
	.toConfig();
